import { render, staticRenderFns } from "./YamlInput2.vue?vue&type=template&id=01f6daaa&"
import script from "./YamlInput2.vue?vue&type=script&lang=js&"
export * from "./YamlInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports